import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthenticationService } from '@dangl/angular-dangl-identity-client';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'da-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatAnchor, RouterLinkActive, RouterLink, MatIcon]
})
export class SidenavComponent {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  logout() {
    this.authenticationService.logout();
    this.router.navigateByUrl('/login');
  }

}
